import React from "react";
import { Link } from "@material-ui/core";
import { LOCALES } from "translation";
import { useLocale } from "hooks";
import { useTranslation } from "react-i18next";
import { useStyles } from "styling/mainStyles";

export const LanguageList = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { localeState, localeActions } = useLocale();

  const handleChangeLocale = (locale) => {
    localeActions.changeLocale(locale);
  };
  return (
    <>
      {LOCALES.map((locale) => (
        <Link
          className={`${classes.localeLink} bold ${
            localeState.locale === locale ? "disabled" : ""
          }`}
          key={locale}
          onClick={() => handleChangeLocale(locale)}
          color={`${localeState.locale !== locale ? "secondary" : ""}`}
        >
          {t(locale).toUpperCase()}
        </Link>
      ))}
    </>
  );
};
